import { useABExperimentVariant } from '@nykaa/experiment-sdk/store/hooks';

export const COUPON_WIDGET_MODE = {
  LEGACY: 'legacy',
  BEST_COUPON: 'bestCoupon',
  MULTICOUPON: 'multicoupon',
} as const;

type CouponWidgetMode = typeof COUPON_WIDGET_MODE[keyof typeof COUPON_WIDGET_MODE];

const BEST_COUPON_EXPERIMENT_ID = 'coupon-widget-best-coupon-ab';
const MULTICOUPON_EXPERIMENT_ID = 'coupon-widget-multicoupon-ab';

const useCouponWidgetMode = (): CouponWidgetMode => {
  const { variant: multicouponVariant, isEligible: multicouponEligible } =
    useABExperimentVariant(MULTICOUPON_EXPERIMENT_ID);
  const { variant: bestCouponVariant, isEligible: bestCouponEligible } =
    useABExperimentVariant(BEST_COUPON_EXPERIMENT_ID);

  if (multicouponEligible && multicouponVariant === COUPON_WIDGET_MODE.MULTICOUPON) {
    return COUPON_WIDGET_MODE.MULTICOUPON;
  }

  if (bestCouponEligible && bestCouponVariant === COUPON_WIDGET_MODE.BEST_COUPON) {
    return COUPON_WIDGET_MODE.BEST_COUPON;
  }

  return COUPON_WIDGET_MODE.LEGACY;
};

export default useCouponWidgetMode;
